import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultComponent } from './layouts/default/default.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AuthGuard } from './auth/auth-guard.service';
import { CanDeactivateGuard } from './shared/canDeactivateGuard';

import { HomeComponent } from './pages/home/home.component';
import { UsuarioListaComponent } from './pages/usuarios/usuarioLista.component';
import { UsuarioEditComponent } from './pages/usuarios/usuarioEdit.component';
import { UsuarioSelfEditComponent } from './pages/usuarios/usuarioSelfEdit.component';
import { RolListaComponent } from './pages/roles/rolLista.component';
import { RolEditComponent } from './pages/roles/rolEdit.component';
import { MensajeUsuarioListaComponent } from './pages/mensaje-usuario/mensajeUsuarioLista.component';
import { MensajeUsuarioEditComponent } from './pages/mensaje-usuario/mensajeUsuarioEdit.component';
import { MensajeUsuarioViewComponent } from './pages/mensaje-usuario/mensajeUsuarioView.component';
import { EstadoListaComponent } from './pages/estados/estadoLista.component';
import { EstadoEditComponent } from './pages/estados/estadoEdit.component';
import { ParametroSistemaListaComponent } from './pages/parametro-sistema/parametroSistemaLista.component';
import { ParametroSistemaEditComponent } from './pages/parametro-sistema/parametroSistemaEdit.component';
import { MenuListaComponent } from './pages/menues/menuLista.component';
import { MenuEditComponent } from './pages/menues/menuEdit.component';
import { MensajeUsuarioTipoListaComponent } from './pages/mensaje-usuario-tipo/mensajeUsuarioTipoLista.component';
import { MensajeUsuarioTipoEditComponent } from './pages/mensaje-usuario-tipo/mensajeUsuarioTipoEdit.component';
import { MensajeUsuarioOpcionEnvioListaComponent } from './pages/mensaje-usuario-opcion-envio/mensajeUsuarioOpcionEnvioLista.component';
import { MensajeUsuarioOpcionEnvioEditComponent } from './pages/mensaje-usuario-opcion-envio/mensajeUsuarioOpcionEnvioEdit.component';
import { MailConfiguracionListaComponent } from './pages/mail-configuracion/mailConfiguracionLista.component';
import { MailConfiguracionEditComponent } from './pages/mail-configuracion/mailConfiguracionEdit.component';
import { TenantListaComponent } from './pages/tenants/tenantLista.component';
import { TenantEditComponent } from './pages/tenants/tenantEdit.component';
import { RolTipoListaComponent } from './pages/rol-tipo/rolTipoLista.component';
import { RolTipoEditComponent } from './pages/rol-tipo/rolTipoEdit.component';
import { FaqListaComponent } from './pages/faq/faqLista.component';
import { FaqEditComponent } from './pages/faq/faqEdit.component';
import { FaqViewComponent } from './pages/faq/faqView.component';
import { PersonaListaComponent } from './pages/usuarios/personaLista.component';
import { PersonaEditComponent } from './pages/usuarios/personaEdit.component';

import { CategoriaSuterhListaComponent } from './pages/categoria-suterh/categoriaSuterhLista.component';
import { CategoriaSuterhEditComponent } from './pages/categoria-suterh/categoriaSuterhEdit.component';
import { MonedaListaComponent } from './pages/moneda/monedaLista.component';
import { MonedaEditComponent } from './pages/moneda/monedaEdit.component';
import { ConversionMonedaListComponent } from './pages/moneda/conversionList.component';
import { ConversionMonedaEditComponent } from './pages/moneda/conversionEdit.component';
import { PaisListaComponent } from './pages/pais/paisLista.component';
import { PaisEditComponent } from './pages/pais/paisEdit.component';
import { TipoDocumentoListaComponent } from './pages/tipo-documento/tipoDocumentoLista.component';
import { TipoDocumentoEditComponent } from './pages/tipo-documento/tipoDocumentoEdit.component';
import { TipoGastoListaComponent } from './pages/tipo-gasto/tipoGastoLista.component';
import { TipoGastoEditComponent } from './pages/tipo-gasto/tipoGastoEdit.component';
import { TipoResponsableIvaListaComponent } from './pages/tipo-responsable-iva/tipoResponsableIvaLista.component';
import { TipoResponsableIvaEditComponent } from './pages/tipo-responsable-iva/tipoResponsableIvaEdit.component';
import { TipoUnidadListaComponent } from './pages/tipo-unidad/tipoUnidadLista.component';
import { TipoUnidadEditComponent } from './pages/tipo-unidad/tipoUnidadEdit.component';
import { TipoComunidadListaComponent } from './pages/tipo-comunidad/tipoComunidadLista.component';
import { TipoComunidadEditComponent } from './pages/tipo-comunidad/tipoComunidadEdit.component';
import { ProvinciaListaComponent } from './pages/provincia/provinciaLista.component';
import { ProvinciaEditComponent } from './pages/provincia/provinciaEdit.component';
import { UnidadFuncionalListaComponent } from './pages/unidad-funcional/unidadFuncionalLista.component';
import { UnidadFuncionalEditComponent } from './pages/unidad-funcional/unidadFuncionalEdit.component';
import { ComunidadListaComponent } from './pages/comunidad/comunidadLista.component';
import { ComunidadEditComponent } from './pages/comunidad/comunidadEdit.component';
import { UfTipoRelacionListaComponent } from './pages/uf-tipo-relacion/ufTipoRelacionLista.component';
import { UfTipoRelacionEditComponent } from './pages/uf-tipo-relacion/ufTipoRelacionEdit.component';
import { ConsorcioListaComponent } from './pages/consorcio/consorcioLista.component';
import { ConsorcioEditComponent } from './pages/consorcio/consorcioEdit.component';
import { CategoriaGastoListaComponent } from './pages/categoria-gasto/categoriaGastoLista.component';
import { CategoriaGastoEditComponent } from './pages/categoria-gasto/categoriaGastoEdit.component';
import { ServicioGastoListaComponent } from './pages/servicio-gasto/servicioGastoLista.component';
import { ServicioGastoEditComponent } from './pages/servicio-gasto/servicioGastoEdit.component';
import { UnidadFuncionalPersonaComponent } from './pages/unidad-funcional/unidadFuncionalPersona.component';
import { ExpensaConfiguracionComponent } from './pages/expensa/expensaConfiguracion.component';
import { ExpensaLiquidacionComponent } from './pages/expensa/expensaLiquidacion.component';
import { ExpensaListaComponent } from './pages/expensa/expensaLista.component';
import { ExpensaEditComponent } from './pages/expensa/expensaEdit.component';
import { GastoListaComponent } from './pages/gasto/gastoLista.component';
import { MiGastoListaComponent } from './pages/gasto/miGastoLista.component';
import { GastoEditComponent } from './pages/gasto/gastoEdit.component';
import { ServicioGrupoListaComponent } from './pages/servicio-grupo/servicioGrupoLista.component';
import { ServicioGrupoEditComponent } from './pages/servicio-grupo/servicioGrupoEdit.component';
import { ContratoListaComponent } from './pages/contrato/contratoLista.component';
import { ContratoEditComponent } from './pages/contrato/contratoEdit.component';
import { IncidenciaUsuarioCategoriaListaComponent } from './pages/incidencia-usuario-categoria/incidenciaUsuarioCategoriaLista.component';
import { IncidenciaUsuarioCategoriaEditComponent } from './pages/incidencia-usuario-categoria/incidenciaUsuarioCategoriaEdit.component';
import { IncidenciaUsuarioBackofficeListaComponent } from './pages/incidencia-usuario/backoffice/incidenciaUsuarioBackofficeLista.component';
import { IncidenciaUsuarioBackofficeEditComponent } from './pages/incidencia-usuario/backoffice/incidenciaUsuarioBackofficeEdit.component';
import { IncidenciaUsuarioListaComponent } from './pages/incidencia-usuario/user/incidenciaUsuarioLista.component';
import { IncidenciaUsuarioEditComponent } from './pages/incidencia-usuario/user/incidenciaUsuarioEdit.component';
import { GremioListaComponent } from './pages/gremio/gremioLista.component';
import { GremioEditComponent } from './pages/gremio/gremioEdit.component';
import { EstadoCivilListaComponent } from './pages/estado-civil/estadoCivilLista.component';
import { EstadoCivilEditComponent } from './pages/estado-civil/estadoCivilEdit.component';
import { AsistenciasListaComponent } from './pages/asistencias/asistenciasLista.component';
import { MotivoInasistenciaEditComponent } from './pages/motivoInasistencia/motivoInasistenciaEdit.component';
import { MotivoInasistenciaListaComponent } from './pages/motivoInasistencia/motivoInasistenciaLista.component';
import { ReporteAsistenciasComponent } from './pages/reportes/reporte-asistencias/reporteAsistencias.component';
import { RubroContableListaComponent } from './pages/rubro-contable/rubroContableLista.component';
import { RubroContableEditComponent } from './pages/rubro-contable/rubroContableEdit.component';
import { ComunidadTipoContratoListaComponent } from './pages/comunidad-tipo-contrato/comunidadTipoContratoLista.component';
import { ComunidadTipoContratoEditComponent } from './pages/comunidad-tipo-contrato/comunidadTipoContratoEdit.component';
import { PedidoListaComponent } from './pages/pedido/pedidoLista.component';
import { PedidoEditComponent } from './pages/pedido/pedidoEdit.component';
import { FormaDePagoListaComponent } from './pages/formas-de-pago/forma-de-pago-lista.component';
import { FormaDePagoEditComponent } from './pages/formas-de-pago/forma-de-pago-edit.component';
import { ProveedoresListaComponent } from './pages/proveedor/proveedores-lista.component';
import { ProveedoresEditComponent } from './pages/proveedor/proveedores-edit.component';
import { BancoListComponent } from './pages/bancos/banco-list.component';
import { BancoEditComponent } from './pages/bancos/banco-edit.component';
import { ComprasComponent } from './pages/pedido/compras/compras.component';
import { RecepcionPedidoComponent } from './pages/pedido/recepcion-pedido/recepcion-pedido.component';
import { ReporteEntregasComponent } from './pages/reportes/reporte-entregas/reporte-entregas.component';
import { EmpleadoEditComponent } from './pages/empleado/empleado-edit.component';
import { EmpleadoListComponent } from './pages/empleado/empleado-list.component';
import { UnidadMedidaEditComponent } from './pages/unidad-medida-materiales/unidad-medida-edit.component';
import { UnidadMedidaMaterialesListComponent } from './pages/unidad-medida-materiales/unidad-medida-materiales-list.component';
import { TipoMaterialEditComponent } from './pages/tipo-materiales/tipo-material-edit.component';
import { TipoMaterialListComponent } from './pages/tipo-materiales/tipo-material-list.component';
import { MaterialesEditComponent } from './pages/materiales/materiales-edit.component';
import { MaterialesListComponent } from './pages/materiales/materiales-list.component';
import { ActividadPrincipalEditComponent } from './pages/actividad-principal/actividad-principal-edit.component';
import { ActividadPrincipalComponent } from './pages/actividad-principal/actividad-principal.component';
import { AlicuotaIvaListComponent } from './pages/alicuota-iva/alicuota-iva-list.component';
import { AlicuotaIvaEditComponent } from './pages/alicuota-iva/alicuota-iva-edit.component';
import { TipoMovimientoListComponent } from './pages/tipo-movimiento/tipo-movimiento-list.component';
import { TipoMovimientoEditComponent } from './pages/tipo-movimiento/tipo-movimiento-edit.component';
import { MedioPagoListComponent } from './pages/medio-pago/medio-pago-list.component';
import { MedioPagoEditComponent } from './pages/medio-pago/medio-pago-edit.component';
import { CuentaEditComponent } from './pages/cuenta/cuentaEdit.component';
import { CuentaListComponent } from './pages/cuenta/cuentaList.component';
import { MovimientoEditComponent } from './pages/movimientos/movimientoEdit.component';
import { MovimientoViewComponent } from './pages/movimientos/movimientoView.component';
import { MovimientoListComponent } from './pages/movimientos/movimientoLista.component';
import { MiMovimientoViewComponent } from './pages/movimientos/miMovimientoView.component';
import { MiMovimientoListComponent } from './pages/movimientos/miMovimientoLista.component';
import { MovimientoFinanciacionComponent } from './pages/movimientos/movimientoFinanciacion.component';
import { MovimientoRecurrenteComponent } from './pages/movimientos/movimientoRecurrente.component';
import { MovimientoPagoMasivoComponent } from './pages/movimientos/movimientoPagoMasivo.component';
import { MovimientoDesdeDocumentoComponent } from './pages/movimientos/movimientoDesdeDocumento.component';
import { GastoRecurrenteComponent } from './pages/gasto/gastoRecurrente.component';
import { GastoDesdeDocumentoComponent } from './pages/gasto/gastoDesdeDocumento.component';

import { ComunidadPublicacionListaComponent } from './pages/publicaciones/comunidadPublicacionLista.component';
import { ComunidadPublicacionEditComponent } from './pages/publicaciones/comunidadPublicacionEdit.component';
import { ComunidadPublicacionViewComponent } from './pages/publicaciones/comunidadPublicacionView.component';

import { JobListaComponent } from './pages/jobs/jobs-lista.component';

import { ReporteConsolidadoCajaComponent } from './pages/reportes/reporte-consolidado-caja/reporte-consolidado-caja.component';
import { ReportePedidoMaterialComponent } from './pages/reportes/reporte-pedido-material/reporte-pedido-material.component';
import { ReporteCuentasDeudorasComponent } from './pages/reportes/reporte-cuentas-deudoras/reporte-cuentas-deudoras.component';

const routes: Routes = [{
  path: '',
  component: DefaultComponent,
  canActivate: [AuthGuard],
  children: [{
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  }, {
    path: 'home',
    component: HomeComponent
  }, {
    path: 'usuario-list',
    component: UsuarioListaComponent
  }, {
    path: 'usuario-edit/:id',
    component: UsuarioEditComponent
  }, {
    path: 'usuario-self-edit',
    component: UsuarioSelfEditComponent
  }, {
    path: "rol-list",
    component: RolListaComponent
  }, {
    path: "rol-edit/:id",
    component: RolEditComponent
  }, {
    path: "mensaje-usuario-list",
    component: MensajeUsuarioListaComponent
  }, {
    path: "mensaje-usuario-edit/:id",
    component: MensajeUsuarioEditComponent
  }, {
    path: "mensaje-usuario-view/:id",
    component: MensajeUsuarioViewComponent
  }, {
    path: "estado-list",
    component: EstadoListaComponent
  }, {
    path: "estado-edit/:id",
    component: EstadoEditComponent
  }, {
    path: "parametro-sistema-list",
    component: ParametroSistemaListaComponent
  }, {
    path: "parametro-sistema-edit/:id",
    component: ParametroSistemaEditComponent
  }, {
    path: "menu-list",
    component: MenuListaComponent
  }, {
    path: "menu-edit/:id",
    component: MenuEditComponent
  }, {
    path: "mensaje-usuario-tipo-list",
    component: MensajeUsuarioTipoListaComponent
  }, {
    path: "mensaje-usuario-tipo-edit/:id",
    component: MensajeUsuarioTipoEditComponent
  }, {
    path: "mensaje-usuario-opcion-envio-list",
    component: MensajeUsuarioOpcionEnvioListaComponent
  }, {
    path: "mensaje-usuario-opcion-envio-edit/:id",
    component: MensajeUsuarioOpcionEnvioEditComponent
  }, {
    path: "mail-configuracion-list",
    component: MailConfiguracionListaComponent
  }, {
    path: "mail-configuracion-edit/:id",
    component: MailConfiguracionEditComponent
  }, {
    path: "tenant-list",
    component: TenantListaComponent
  }, {
    path: "tenant-edit/:id",
    component: TenantEditComponent
  }, {
    path: "tenant-copy/:id",
    component: TenantEditComponent
  }, {
    path: "rol-tipo-list",
    component: RolTipoListaComponent
  }, {
    path: "rol-tipo-edit/:id",
    component: RolTipoEditComponent
  }, {
    path: "faq-list",
    component: FaqListaComponent
  }, {
    path: "faq-edit/:id",
    component: FaqEditComponent
  },{
    path: "faq-view",
    component: FaqViewComponent
  },{
    path: "persona-list",
    component: PersonaListaComponent
  }, {
    path: "persona-edit/:id",
    component: PersonaEditComponent
  }, {
    path: "categoria-suterh-list",
    component: CategoriaSuterhListaComponent
  }, {
    path: "categoria-suterh-edit/:id",
    component: CategoriaSuterhEditComponent
  }, {
    path: "moneda-list",
    component: MonedaListaComponent
  }, {
    path: "moneda-edit/:id",
    component: MonedaEditComponent
  }, {
    path: "pais-list",
    component: PaisListaComponent
  }, {
    path: "pais-edit/:id",
    component: PaisEditComponent
  }, {
    path: "tipo-documento-list",
    component: TipoDocumentoListaComponent
  }, {
    path: "tipo-documento-edit/:id",
    component: TipoDocumentoEditComponent
  }, {
    path: "tipo-gasto-list",
    component: TipoGastoListaComponent
  }, {
    path: "tipo-gasto-edit/:id",
    component: TipoGastoEditComponent
  }, {
    path: "tipo-responsable-iva-list",
    component: TipoResponsableIvaListaComponent
  }, {
    path: "tipo-responsable-iva-edit/:id",
    component: TipoResponsableIvaEditComponent
  }, {
    path: "tipo-unidad-list",
    component: TipoUnidadListaComponent
  }, {
    path: "tipo-unidad-edit/:id",
    component: TipoUnidadEditComponent
  }, {
    path: "tipo-comunidad-list",
    component: TipoComunidadListaComponent
  }, {
    path: "tipo-comunidad-edit/:id",
    component: TipoComunidadEditComponent
  }, {
    path: "provincia-list",
    component: ProvinciaListaComponent
  }, {
    path: "provincia-edit/:id",
    component: ProvinciaEditComponent
  }, {
    path: "unidad-funcional-list",
    component: UnidadFuncionalListaComponent
  }, {
    path: "unidad-funcional-edit/:id",
    component: UnidadFuncionalEditComponent
  }, {
    path: "unidad-funcional-persona",
    component: UnidadFuncionalPersonaComponent
  }, {
    path: "comunidad-list",
    component: ComunidadListaComponent
  }, {
    path: "comunidad-edit/:id",
    component: ComunidadEditComponent
  }, {
    path: "comunidad-publicacion-list",
    component: ComunidadPublicacionListaComponent
  },{
    path: "comunidad-publicacion-edit/:id",
    component: ComunidadPublicacionEditComponent
  },{
    path: "comunidad-publicacion-view/:id",
    component: ComunidadPublicacionViewComponent
  }, {
    path: "uf-tipo-relacion-list",
    component: UfTipoRelacionListaComponent
  }, {
    path: "uf-tipo-relacion-edit/:id",
    component: UfTipoRelacionEditComponent
  }, {
    path: "consorcio-list",
    component: ConsorcioListaComponent
  }, {
    path: "consorcio-edit/:id",
    component: ConsorcioEditComponent
  }, {
    path: "categoria-gasto-list",
    component: CategoriaGastoListaComponent
  }, {
    path: "categoria-gasto-edit/:id",
    component: CategoriaGastoEditComponent
  }, {
    path: "servicio-gasto-list",
    component: ServicioGastoListaComponent
  }, {
    path: "servicio-gasto-edit/:id",
    component: ServicioGastoEditComponent
  }, {
    path: "expensa-configuracion",
    component: ExpensaConfiguracionComponent
  }, {
    path: "expensa-liquidacion",
    component: ExpensaLiquidacionComponent
  }, {
    path: "expensa-list",
    component: ExpensaListaComponent
  }, {
    path: "expensa-edit/:id",
    component: ExpensaEditComponent
  }, {
    path: "gasto-list",
    component: GastoListaComponent
  }, {
    path: "mi-gasto-list",
    component: MiGastoListaComponent
  }, {
    path: "gasto-edit/:id",
    component: GastoEditComponent
  }, {
    path: "servicio-grupo-list",
    component: ServicioGrupoListaComponent
  }, {
    path: "servicio-grupo-edit/:id",
    component: ServicioGrupoEditComponent
  }, {
    path: "contrato-list",
    component: ContratoListaComponent
  }, {
    path: "contrato-edit/:id",
    component: ContratoEditComponent
  }, {
    path: "incidencia-usuario-list-bo",
    component: IncidenciaUsuarioBackofficeListaComponent
  }, {
    path: "incidencia-usuario-edit-bo/:id",
    component: IncidenciaUsuarioBackofficeEditComponent
  }, {
    path: "incidencia-usuario-list",
    component: IncidenciaUsuarioListaComponent
  }, {
    path: "incidencia-usuario-edit/:id",
    component: IncidenciaUsuarioEditComponent
  }, {
    path: "incidencia-usuario-categoria-list",
    component: IncidenciaUsuarioCategoriaListaComponent
  }, {
    path: "incidencia-usuario-categoria-edit/:id",
    component: IncidenciaUsuarioCategoriaEditComponent
  }, {
    path: "material-list",
    component: MaterialesListComponent
  }, {
    path: "material-edit/:id",
    component: MaterialesEditComponent
  }, {
    path: "tipo-material-list",
    component: TipoMaterialListComponent
  }, {
    path: "tipo-material-edit/:id",
    component: TipoMaterialEditComponent
  }, {
    path: "unidad-medida-list",
    component: UnidadMedidaMaterialesListComponent
  }, {
    path: "unidad-medida-edit/:id",
    component: UnidadMedidaEditComponent
  }, {
    path: "gremio-list",
    component: GremioListaComponent
  }, {
    path: "gremio-edit/:id",
    component: GremioEditComponent
  }, {
    path: "estado-civil-list",
    component: EstadoCivilListaComponent
  }, {
    path: "estado-civil-edit/:id",
    component: EstadoCivilEditComponent
  }, {
    path: "asistencia-list",
    component: AsistenciasListaComponent
  }, {
    path: "empleado-list",
    component: EmpleadoListComponent
  }, {
    path: "empleado-edit/:id",
    component: EmpleadoEditComponent
  }, {
    path: "motivo-inasistencia-list",
    component: MotivoInasistenciaListaComponent
  }, {
    path: "motivo-inasistencia-edit/:id",
    component: MotivoInasistenciaEditComponent
  }, {
    path: "reporte-empleado-asistencias",
    component: ReporteAsistenciasComponent
  }, {
    path: "reporte-pedido-entregas",
    component: ReporteEntregasComponent
  }, {
    path: "rubro-contable-list",
    component: RubroContableListaComponent
  }, {
    path: "rubro-contable-edit/:id",
    component: RubroContableEditComponent
  }, {
    path: "comunidad-tipo-contrato-list",
    component: ComunidadTipoContratoListaComponent
  }, {
    path: "comunidad-tipo-contrato-edit/:id",
    component: ComunidadTipoContratoEditComponent
  }, {
    path: "pedido-list",
    component: PedidoListaComponent
  }, {
    path: "pedido-edit/:id",
    component: PedidoEditComponent, canDeactivate: [CanDeactivateGuard]
  }, {
    path: "forma-de-pago-list",
    component: FormaDePagoListaComponent
  }, {
    path: "forma-de-pago-edit/:id",
    component: FormaDePagoEditComponent
  }, {
    path: "proveedores-list",
    component: ProveedoresListaComponent
  }, {
    path: "proveedores-edit/:id",
    component: ProveedoresEditComponent
  }, {
    path: "banco-list",
    component: BancoListComponent
  }, {
    path: "banco-edit/:id",
    component: BancoEditComponent
  }, {
    path: "compras-list",
    component: ComprasComponent
  }, {
    path: "recepcion-pedido",
    component: RecepcionPedidoComponent
  }, {
    path: "actividad-principal-list",
    component: ActividadPrincipalComponent
  }, {
    path: "actividad-principal-edit/:id",
    component: ActividadPrincipalEditComponent
  }, {
    path: "alicuota-iva-list",
    component: AlicuotaIvaListComponent
  }, {
    path: "alicuota-iva-edit/:id",
    component: AlicuotaIvaEditComponent
  }, {
    path: "medio-pago-list",
    component: MedioPagoListComponent
  }, {
    path: "medio-pago-edit/:id",
    component: MedioPagoEditComponent
  }, {
    path: "tipo-movimiento-list",
    component: TipoMovimientoListComponent
  }, {
    path: "tipo-movimiento-edit/:id",
    component: TipoMovimientoEditComponent
  }, {
    path: "cuenta-list",
    component: CuentaListComponent
  }, {
    path: "cuenta-edit/:id",
    component: CuentaEditComponent
  }, {
    path: "movimiento-list",
    component: MovimientoListComponent
  }, {
    path: "mi-movimiento-list",
    component: MiMovimientoListComponent
  }, {
    path: "movimiento-edit/:id",
    component: MovimientoEditComponent
  }, {
    path: "movimiento-view/:id",
    component: MovimientoViewComponent
  }, {
    path: "mi-movimiento-view/:id",
    component: MiMovimientoViewComponent
  }, {
    path: "movimiento-financiacion",
    component: MovimientoFinanciacionComponent
  }, {
    path: "movimientos-desde-documentos", 
    component: MovimientoDesdeDocumentoComponent
  }, {
    path: "movimientos-pago-masivos",
    component: MovimientoPagoMasivoComponent
  }, {
    path: "movimientos-recurrentes",
    component: MovimientoRecurrenteComponent
  }, {
    path: "reporte-consolidado-caja",
    component: ReporteConsolidadoCajaComponent
  }, {
    path: "moneda-conversion-list",
    component: ConversionMonedaListComponent
  }, {
    path: "moneda-conversion-edit/:id",
    component: ConversionMonedaEditComponent
  }, {
    path: "job-list",
    component: JobListaComponent
  }, {
    path: "reporte-pedido-materiales",
    component: ReportePedidoMaterialComponent
  }, {
    path: "reporte-cuentas-deudoras",
    component: ReporteCuentasDeudorasComponent
  }, {
    path: "gastos-desde-documentos", 
    component: GastoDesdeDocumentoComponent
  }, {
    path: "gastos-recurrentes",
    component: GastoRecurrenteComponent
  }
  ]
}, {
  path: 'auth',
  loadChildren: './auth/auth.module#AuthModule',
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
